 <template>
  <div class="home">
    Choose a treatment now
    <app-choose-treatment> </app-choose-treatment>
  </div>
</template>

<script>
import ChooseTreatment from "@/components/BookingApp/UserView/Menu/ChooseTreatment.vue";
export default {
  name: "Home",
  components: {
    appChooseTreatment: ChooseTreatment,
  },
};
</script>

<style>
</style>